import React, { useCallback, useRef, } from 'react';
import { cssColorValue, desktopMestoBold, IconChevronDown, IconChevronUp, spacer8, } from '@spotify-internal/encore-web';
import styled from 'styled-components';
import { ButtonTertiaryLink } from '../../Link/Link';
import { NavBarPopover } from '../Popover';
import { hexToRgba } from '../../../utils/colorConversion';
const NavBarPopoverButton = styled(ButtonTertiaryLink) `
  cursor: pointer;
  ${desktopMestoBold};

  && {
    color: ${props => { var _a; return hexToRgba(((_a = props.colors) === null || _a === void 0 ? void 0 : _a.text) || cssColorValue('textBase'), 0.75); }};
    text-decoration: none;

    &:active,
    &:hover,
    &:focus {
      color: ${props => { var _a; return ((_a = props.colors) === null || _a === void 0 ? void 0 : _a.text) || cssColorValue('textBase'); }};
      transform: none;
    }

    & > * {
      margin-inline-start: ${spacer8};
    }
  }
`;
const StyledIconChevronDown = styled(IconChevronDown) `
  transform: translateY(1px);
`;
const StyledIconChevronUp = styled(IconChevronUp) `
  transform: translateY(3px);
`;
export const S4XDropdown = ({ popoverLinks, colors, chevronCopy, label, onOpen, onClose, opened, }) => {
    const timeout = useRef(null);
    const handleOnMouseDown = useCallback(e => {
        e.preventDefault();
        if (opened) {
            onClose();
        }
        else {
            onOpen();
        }
    }, [opened, onOpen, onClose]);
    const handleOnKeyDown = useCallback(e => {
        if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            if (opened) {
                onClose();
            }
            else {
                onOpen();
            }
        }
    }, [opened, onOpen, onClose]);
    const handleOnMouseLeave = useCallback(() => {
        timeout.current = setTimeout(() => {
            onClose();
        }, 500);
    }, [onClose]);
    const handleOnMouseEnter = useCallback(() => {
        if (timeout.current) {
            clearTimeout(timeout.current);
            timeout.current = null;
        }
        onOpen();
    }, [onOpen]);
    return (React.createElement(NavBarPopover, { isOpen: opened, links: popoverLinks, onMouseEnter: handleOnMouseEnter, onMouseLeave: handleOnMouseLeave },
        React.createElement(NavBarPopoverButton, { colors: colors, href: "", iconTrailing: () => opened ? (React.createElement(StyledIconChevronUp, { size: "small", "aria-label": chevronCopy.closed })) : (React.createElement(StyledIconChevronDown, { size: "small", "aria-label": chevronCopy.open })), trackingAttributes: ['', ''], onKeyDown: handleOnKeyDown, onMouseDown: handleOnMouseDown }, label)));
};
//# sourceMappingURL=index.js.map